module.exports = __webpack_public_path__ + "img/beta-signup-mark.ae90a29.jpg";